import { Loader } from '@sd/components';
import { useAsyncEffect } from '@sd/shared';
import { logout } from '../utils/logout';

export const LogoutScene = () => {
  useAsyncEffect(async () => {
    await logout();
  }, []);
  return <Loader loading />;
};
